import { render } from "./AddEditTerminals.vue?vue&type=template&id=34dac56e&scoped=true"
import script from "./AddEditTerminals.vue?vue&type=script&lang=js"
export * from "./AddEditTerminals.vue?vue&type=script&lang=js"

import "./AddEditTerminals.vue?vue&type=style&index=0&id=34dac56e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dac56e"]])

export default __exports__